import { resetPassword } from '@ax/service';
import { ProviderResetPasswordInput } from '@ax/service/src/provider-interface';
import { useMutation } from '@tanstack/react-query';

export function useResetPassword() {
  const resetPasswordMutation = useMutation({
    mutationKey: ['reset-password'],
    mutationFn: (passwordDataInput: ProviderResetPasswordInput) => resetPassword(passwordDataInput),
    onError: (error: any) => {
      return error;
    },
  });

  return resetPasswordMutation;
}
